"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _itinerary = require("../utils/itinerary.utils");
function $fareFamiliesService(_ref) {
  var brandedFares = _ref.brandedFares,
    fareFamilies = _ref.fareFamilies,
    _ref$apiState = _ref.apiState,
    apiState = _ref$apiState === void 0 ? {} : _ref$apiState,
    _ref$isMultiPNR = _ref.isMultiPNR,
    isMultiPNR = _ref$isMultiPNR === void 0 ? false : _ref$isMultiPNR,
    _ref$itineraries = _ref.itineraries,
    itineraries = _ref$itineraries === void 0 ? {} : _ref$itineraries,
    currencyStore = _ref.currencyStore;
  return {
    getFareFamilies: function getFareFamilies(itineraryId) {
      var fareFamiliesArr = (0, _get2.default)(fareFamilies[itineraryId], 'fareFamilies', []);
      var hasFareFamilies = (0, _get2.default)(itineraries, itineraryId + ".hasFareFamilies", false);
      return isMultiPNR && !hasFareFamilies ? (0, _itinerary.calculateFareFamilyDifference)(fareFamiliesArr, currencyStore) : fareFamiliesArr;
    },
    getBrandedFares: function getBrandedFares(code) {
      return (0, _get2.default)(brandedFares, code, {});
    },
    isFareFamilyLoading: function isFareFamilyLoading(itineraryId) {
      return apiState[itineraryId] === _constants.API_STATE.LOADING;
    },
    didFareFamilyFail: function didFareFamilyFail(itineraryId) {
      return apiState[itineraryId] === _constants.API_STATE.FAILED;
    },
    didFareFamilyComplete: function didFareFamilyComplete(itineraryId) {
      return apiState[itineraryId] === _constants.API_STATE.SUCCESS;
    }
  };
}
var _default = exports.default = $fareFamiliesService;